<template>
  <div>
<!--    <tci-service-head :title="title" :subtitle="subtitle">-->
      <iframe
          ref="myIframe"
          width="100%"
          src="/aps2.htm"
          scrolling="no"
          @load="adjustIframeHeight"
      ></iframe>
<!--    </tci-service-head>-->
    <tci-contact-footer ref="targetFooter" color="white">
    </tci-contact-footer>
  </div>
<!--  <tci-solution subtitle="" :title="$t('solution.mes.title')" :infos='$i18n.locale=="zh"?infos:infos_ja' :images = '$i18n.locale=="zh"?infos:infos_ja'></tci-solution>-->
</template>

<script>
// import TciSolution from "@/components/TciSolution.vue";
// import TciServiceHead from "@/components/TciServiceHead.vue";
import TciContactFooter from "@/components/TciContactFooter.vue";

export default {
  name: "CompanyService",
  components: {
    // "tci-service-head": TciServiceHead,
    "tci-contact-footer": TciContactFooter
    // "tci-solution": TciSolution
  },
  data: () => ({
    title: "大宇宙Easy-APS",
    // subtitle: "大宇宙Easy-APS"
  }),
  mounted() {
    // 2. 监听来自 Iframe 的消息
    window.addEventListener('message', this.handleIframeMessage);
  },
  beforeUnmount() {
    // 组件销毁时记得移除监听
    window.removeEventListener('message', this.handleIframeMessage);
  },
  methods: {
    adjustIframeHeight() {
      try {
        const iframe = this.$refs.myIframe;
        // 获取 iframe 内部文档的实际高度
        const doc = iframe.contentDocument || iframe.contentWindow.document;
        // 设置 iframe 高度为内容高度，使其撑开
        iframe.style.height = doc.body.scrollHeight + 'px';
      } catch (e) {
        console.error('无法访问iframe内容', e);
      }
    },
    // 处理消息的核心方法
    handleIframeMessage(event) {
      // 安全起见，建议判断一下 origin，防止恶意消息
      if (event.origin !== window.location.origin) return;

      // 判断消息类型是否为我们约定的 'scroll-to-footer'
      if (event.data && event.data.action === 'scroll-to-footer') {
        this.scrollToFooter();
      }
    },
    scrollToFooter() {
      // 3. 获取目标元素并执行平滑滚动
      let targetEl = this.$refs.targetFooter;
      if (!targetEl) return;
      console.log(targetEl)
      if (targetEl.$el) {
        targetEl = targetEl.$el;
      }

      // 3. 再次确认这是一个 DOM 元素，并且拥有 scrollIntoView 方法
      if (targetEl.scrollIntoView) {
        targetEl.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      } else {
        console.error('未能获取到有效的 DOM 元素进行滚动', targetEl);
      }
    }
  }
};

</script>
